import Utils from "../utils/utilities"

export default class ListingHelpers {

    private static ratingHelper(input: string): string {
        return `rating-${input.toLowerCase()
            .replace('villas', 'villa')
            .replace('na', 'villa')
            .replace(/\.5/g, '-plus')
            .replace(/\+/g, '-plus')
            .replace('luxury', 'platinum')}`
    }

    private static imageMapper(list: any): void {
        if (Utils.isDefined(list.content) && !Utils.isDefined(list.content.image)) {
            list.content.image = '/hotlist/assets/images/destination-image-default.jpg'
        }
    }

    private static vRatingMapper(list: any): void {
        if (Utils.isDefined(list.content) && Utils.isDefined(list.content.vRating)) {
            list.content.vRating = ListingHelpers.ratingHelper(list.content.vRating)
        }
    }

    private static durationMapper(list: any): void {
        if (Utils.isDefined(list.duration)) list.duration = Utils.pluralise(list.duration, 'night', 'nights')
    }

    private static partyMapper(list: any): void {
        if (Utils.isNotEmpty(list.party)) {
            list.guests = Utils.pluralise(list.party.reduce((accum, next) => {
                accum += Object.keys(next).reduce((a, n) => {
                    const nextValue: any = next[n]
                    if (Utils.isDefined(nextValue)) {
                        if (Utils.isDefined(nextValue.length)) {
                            a += nextValue.length
                        } else a += nextValue

                        return a
                    }
                }, 0)

                return accum
            }, 0), 'guest', 'guests')
        }
    }

    private static departureMapper(list: any): void {
        if (Utils.isDefined(list.departure)) {
            list.departure = new Date(list.departure).toLocaleDateString('en-GB', {
                day: 'numeric',
                month: 'short',
                year: 'numeric'
            })
        }
    }

    private static descriptionMapper(list: any): void {
        if (Utils.isDefined(list.content)) {
            list.parentDescription = Utils.isNotBlank(list.content.parentDescription) ? list.content.parentDescription : list.parentDescription
            list.description = Utils.isNotBlank(list.content.description) ? list.content.description : list.description
        }
    }

    public static processLists(lists: Array<any>): Array<any> {
        return lists.map(list => {
            ListingHelpers.imageMapper(list)
            ListingHelpers.vRatingMapper(list)
            ListingHelpers.durationMapper(list)
            ListingHelpers.partyMapper(list)
            ListingHelpers.departureMapper(list)
            ListingHelpers.descriptionMapper(list)

            return list
        })
    }
}